export const SUPERADMINMANAGEORG = 'SUPERADMINMANAGEORG'
export const GODMODEMANAGEORG = 'GODMODEMANAGEORG'